import { createAsyncThunk } from '@reduxjs/toolkit';

import api from 'api';

/** Summary + PDF of a candidate's assessment retainer (signed copy when signed). */
export const fetchAssessmentAgreement = createAsyncThunk(
    'assessmentAgreement/fetch',
    (userId: string) => api.signRetainer.getAssessmentAgreementDocument(userId)
);
